<template>
  <div>
    <b-container>
      <b-row>
        <b-col class="p-0">
          <p class="text-justify mt-3">
            {{ $t("depending_of_how_big_the_report_is") | capitalize }}.
            <br>
            {{ $t("we_will_send_you_an_email_with_a_link") | capitalize }}.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="p-0">
          <b-form-group :label="$t('email') | capitalize">
            <b-form-input v-model="email"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <b-row class="modal-footer mt-4">
      <b-button class="btn-outline-dark" @click="cancel">
        {{ $t("cancel") | capitalize }}
      </b-button>
      <b-button :disabled="!isValid" class="btn-outline-red" @click="exportData" id="submit-export-btn">
        {{ $t("export") | capitalize }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  name: "SnapshotExportForm",
  computed: {
    ...mapState("user", ["user"]),
    isValid () {
      return this.email
    },
    query () {
      const query = { ...this.$route.query }
      delete query.page
      delete query.limit
      return query
    }
  },
  data () {
    return {
      email: null,
    }
  },
  methods: {
    ...mapMutations("alert", ["success", "error"]),
    exportData () {
      let data = {
        email: this.email,
        query: this.query,
        user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }
      console.log(this.query)
      let closeoutId = this.$route.params.closeoutId
      this.$api.distributions.exportSnapshot(closeoutId, data)
        .then(response => {
          let msg = `Snapshot export started: ${response.statusText}`
          this.success(msg)
          this.$bvModal.hide("snapshot-export-modal")
        })
        .catch(error => {
          let msg = `Export error: ${JSON.stringify(error.response.data)}`
          this.error(msg)
        })
    },
    cancel () {
      this.$bvModal.hide("snapshot-export-modal")
    },
  },
  mounted () {
    this.email = this.user.email
  },
}
</script>
